import React from "react";
import { ProducerPreviewSummaryTemplate } from "themes/administration/producer/components";

function ProducerPreviewSummary(props) {
    return <ProducerPreviewSummaryTemplate {...props} />;
}

export default ProducerPreviewSummary;
